import { useCallback, useMemo, useState } from 'react';
import {
  extractErrorMessage,
  INTERNAL_PORTAL_WORK_IN_PROGRESS_DISMISSED_KEY,
  PreferenceControllerGetPreferencesParamsTypeEnum,
  PreferenceControllerUpsertPreferencesParamsTypeEnum,
  PreferenceDtoTypeEnum,
  useGetPreferences,
  useUpdatePreferences,
} from '@sib/api';
import { useTranslation } from '@sib/i18n';
import { useNotification } from '@sib/notifications';

export const useWorkInProgressPopup = () => {
  const { t } = useTranslation();
  const { open: openNotification } = useNotification();
  const [optimisticallyDismissed, setOptimisticallyDismissed] = useState(false);

  const { data, isLoading } = useGetPreferences({
    key: INTERNAL_PORTAL_WORK_IN_PROGRESS_DISMISSED_KEY,
    type: PreferenceControllerGetPreferencesParamsTypeEnum.User,
  });

  const isDismissed = useMemo(() => {
    if (optimisticallyDismissed) return true;

    const userPreference = data?.items.find(
      item => item.type === PreferenceDtoTypeEnum.User
    )?.value;

    return !!userPreference;
  }, [data, optimisticallyDismissed]);

  const { mutate, isPending } = useUpdatePreferences({
    onError: error =>
      openNotification({
        type: 'error',
        message: extractErrorMessage(error) || t('error'),
      }),
  });

  const dismiss = useCallback(() => {
    setOptimisticallyDismissed(true);

    mutate({
      key: INTERNAL_PORTAL_WORK_IN_PROGRESS_DISMISSED_KEY,
      query: {
        key: INTERNAL_PORTAL_WORK_IN_PROGRESS_DISMISSED_KEY,
        type: PreferenceControllerUpsertPreferencesParamsTypeEnum.User,
      },
      data: {
        value: true,
      },
    });
  }, [mutate]);

  return {
    isOpen: !isLoading && !isDismissed,
    dismiss,
    isDismissing: isPending,
  };
};
